module.exports = __webpack_public_path__ + "static/media/portada_malbec.336c1556.jpg";